module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = 43
// module chunks = 221